import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as c3 from 'c3';
const monthnames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
@Component({
  selector: 'app-bar-line-combo-chart-popup',
  templateUrl: './bar-line-combo-chart-popup.component.html',
  styleUrls: ['./bar-line-combo-chart-popup.component.scss']
})
export class BarLineComboChartPopupComponent implements OnInit, AfterViewInit {

  @ViewChild('graphDiv', { static: true }) graphDiv: ElementRef;
  @ViewChild('graphComboDiv', { static: true }) graphComboDiv: ElementRef;
  @Output() factorySummary = new EventEmitter<any>();
  @Output() currentDate = new EventEmitter<any>();
  @Output() currrentFilter = new EventEmitter<any>();
  public oneDate: any;
  public monthName: any;
  currentEndWeek: any;
  emitDataList: any;
  colorList = ['#D26999', '#8F82C7'];
  unit = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    const daDate = this.getLocalStorageData('selectedDATimeFilter');
    this.currentEndWeek = '';
    // const startOfMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    // const endOfMonth = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    this.emitDataList = {
      appliedFilterType: daDate ? daDate.appliedFilterType : '',
      dateObj: new Date(daDate.endOfMonth),
      selectedHr: daDate.selectedHr,
      endWeekFromSelectedDate: daDate.endWeekFromSelectedDate,
      startQuarterMonth: null
    };
    this.oneDate = this.emitDataList.dateObj;
    this.monthName = this.oneDate.toLocaleString('en-us', { month: 'short' });

  }

  getLocalStorageData(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.data) {
        this.unit = this.data.unit;
        // this.data.xAxisLabels = ['x'].concat(this.data.xAxisLabels);
        // this.data.barData = ['Sum of Delivered Quantity'].concat(this.data.barData);
        // this.data.lineData = ['Cost %'].concat(this.data.lineData);
        this.drawGraph();
      }
    }, 0);
  }

  drawGraph() {
    const thisObj = this;
    c3.generate({
      bindto: this.graphComboDiv.nativeElement,
      padding: {
        top: 0,
        bottom: 0
      },
      size: {
        height: 400,
        width: 800
      },
      data: {
        x: 'x',
        columns: [
          this.data.xAxisLabels,
          this.data.barData,
          this.data.lineData,
        ], //
        names: { //
          data1: 'Sum of Delivered Quantity', //
          data2: 'Cost %' //
        }, //
        axes: { //
          data1: 'y', //
          data2: 'y2' //
        }, //
        type: 'bar', //
        types: { //
          data2: 'line', //
        }, //
        colors: { //
          data1: '#BF2A6E', //
          data2: '#515CB4', //
        }, //
      }, //
      point: { //
        show: false //
      }, //
      tooltip: { //
        show: true, //
        format: { //
          title: (x: number) => (this.emitDataList &&
            (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year')
            ? monthnames[x - 1] : (x + ' ' + this.monthName + ' ')),
          value: (x: number) => x > 100 ? (x / thisObj.data.divisionNumber).toFixed(2) + thisObj.data.signType : x.toFixed(2) + '%'
        }
      },
      bar: {
        width: 5
      },
      axis: {
        y: {
          label: {
            text: 'Delivered Quantity',
            position: 'outer-middle'
          },
          tick: {
            format: ((x) => x / thisObj.data.divisionNumber + thisObj.data.signType)
          }
        },
        y2: {
          label: {
            text: 'Cost %',
            position: 'outer-middle'
          },
          show: true,
          tick: {

            format: (d: any) => d + '%'
          }
        },
        x: {
          label: {
            text: ((this.emitDataList && (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year'))
              ? 'Month' : 'Date'),
            position: 'outer-center'
          },
        }

      }
    });
  }

}
